import React from "react"
import styled, { css } from "styled-components"
import { em } from "polished"

const Current = ({ translations, data, Title, Styled, className }) => {
  if (!data?.current) return null

  return (
    <Container className={className}>
      <Title as="h2">{translations.global.current}</Title>

      <Content>
        <Styled dangerouslySetInnerHTML={{ __html: data.current }} />
      </Content>
    </Container>
  )
}

export default Current

const Container = styled.section`
  padding: ${em(20)};
  background-color: ${({ theme }) =>
    theme.components?.current?.backgroundColor};
  border: 1px solid
    ${({ theme }) => theme.components?.current?.borderColor || `#ddd`};
  border-radius: ${({ theme }) => theme.components?.current?.borderRadius};

  ${({ theme }) =>
    theme.components?.current?.color &&
    css`
      color: ${({ theme }) => theme.components.current.color};
    `}
`

const Content = styled.div`
  margin-top: ${em(20)};
`
